export const Marquee = ({
  items = [],
  className = "",
  textClassName = "text-spa-slate",
}) => {
  const content = [...items, ...items];
  return (
    <div
      className={`relative overflow-hidden whitespace-nowrap border-y border-spa-slate/10 py-5 ${className}`}
      data-testid="editorial-marquee"
    >
      <div className="flex w-max animate-marquee">
        {content.map((item, i) => (
          <span
            key={i}
            className={`font-serif italic text-2xl sm:text-3xl mx-6 flex items-center gap-6 ${textClassName}`}
          >
            {item}
            <span className="text-spa-terracotta not-italic font-sans text-base">
              ✦
            </span>
          </span>
        ))}
      </div>
    </div>
  );
};
